import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router'
import { Row, Col, Button, Layout, Menu, Icon, PageHeader, Avatar, Dropdown, Modal, Spin, Form, FormModel, Input, Select, InputNumber, Tag, Table, Divider, Badge, message, Tree, Steps, Checkbox, Collapse, Radio,Popover,TreeSelect } from 'ant-design-vue';
import Space from 'ant-design-vue/lib/space';
import SlideUpDown from 'vue-slide-up-down';
import 'ant-design-vue/lib/space/style';
import ZhTW from 'date-format-parse/lib/locale/zh-tw';
import DatePicker from '@fubonlife/vue2-datepicker';
import VueMask from 'v-mask';
import PincodeInput from 'vue-pincode-input';
import VueLazyload from 'vue-lazyload'
import App from './App.vue'
import router from './router'
import global from './plugins/global';
import EnumData from './plugins/global/enumData';
import Api from './plugins/api'
import VueRx from 'vue-rx';
import User from './plugins/user';
import store from './store';
import encryptionDecryption from './plugins/encryptionDecryption/index';
import VueCookies from 'vue-cookies';
import DateUtils from './plugins/DateUtils/DateUtils';
import Cache from './plugins/cache'
import '@/style/layout.scss';
import '@/style/vendors/tailwind-compile.css';
import '@fubonlife/vue2-datepicker/index.css';
import TwDateFormatter from './plugins/tw-date-formatter';
import ButtonPrimary from '@/components/shared/buttons/ButtonPrimary.vue'
import MultiSelectModal from '@/components/shared/modals/MultiSelectModal.vue'
import ButtonSecondary from '@/components/shared/buttons/ButtonSecondary.vue'
import ButtonQA from '@/components/shared/buttons/ButtonQA.vue'

Vue.use(VueMask);
Vue.use(VueLazyload)
Vue.use(Vuex);
Vue.use(VueRx)
Vue.use(Api, {});
Vue.use(User, { router, message });
Vue.use(global, { router });
Vue.use(EnumData);
Vue.use(encryptionDecryption, {});
Vue.use(VueRouter);
Vue.use(FormModel);
Vue.use(Modal);
Vue.use(VueCookies);
Vue.use(DateUtils);
Vue.use(Cache, { router })
Vue.component(Space.name, Space);
Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component(Select.Option.name, Select.Option);
Vue.component(Select.OptGroup.name, Select.OptGroup);
Vue.component(TreeSelect.name, TreeSelect);
Vue.component(TreeSelect.TreeNode.name, TreeSelect.TreeNode);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Layout.name, Layout);
Vue.component(Layout.Sider.name, Layout.Sider);
Vue.component(Layout.Header.name, Layout.Header);
Vue.component(Layout.Content.name, Layout.Content);
Vue.component(Layout.Footer.name, Layout.Footer);
Vue.component(Menu.name, Menu);
Vue.component(Menu.SubMenu.name, Menu.SubMenu);
Vue.component(Menu.Item.name, Menu.Item);
Vue.component(PageHeader.name, PageHeader);
Vue.component(Avatar.name, Avatar);
Vue.component(Icon.name, Icon);
Vue.component(Dropdown.name, Dropdown);
Vue.component(Modal.name, Modal);
Vue.component(Spin.name, Spin);
Vue.component(Form.name, Form);
Vue.component(Form.Item.name, Form.Item);
Vue.component(FormModel.name, FormModel);
Vue.component(FormModel.Item.name, FormModel.Item);
Vue.component(Input.name, Input);
Vue.component(InputNumber.name, InputNumber);
Vue.component(Input.Password.name, Input.Password);
Vue.component(Tag.name, Tag);
// Vue.component(DatePicker.name, DatePicker);
// Vue.component(DatePicker.RangePicker.name, DatePicker.RangePicker);
Vue.component(Table.name, Table);
Vue.component(Table.ColumnGroup.name, Table.ColumnGroup);
Vue.component(Table.Column.name, Table.Column);
Vue.component(Divider.name, Divider);
Vue.component(Badge.name, Badge);
Vue.component(Tree.name, Tree);
Vue.component(Steps.name, Steps);
Vue.component(Steps.Step.name, Steps.Step);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Checkbox.Group.name, Checkbox.Group);
Vue.component(Radio.name, Radio);
Vue.component(Radio.Group.name, Radio.Group);
Vue.component(Radio.Button.name, Radio.Button);
Vue.component(Collapse.name, Collapse);
Vue.component(Collapse.Panel.name, Collapse.Panel);
Vue.component('slide-up-down', SlideUpDown);
Vue.component('PincodeInput', PincodeInput);
Vue.component(Popover.name, Popover);
Vue.component("ButtonPrimary", ButtonPrimary);
Vue.component("MultiSelectModal", MultiSelectModal);
Vue.component("ButtonSecondary", ButtonSecondary);
Vue.component("ButtonQA", ButtonQA);

Vue.use(TwDateFormatter);
Vue.component('DatePicker', DatePicker);
DatePicker.locale('zh-tw', {
	formatLocale: ZhTW,
	yearFormat: (year) => {
		const twYear = year - 1911;
		return `${twYear} 年`;
	},
	monthFormat: 'MMM',
	monthBeforeYear: false,
});

Vue.config.productionTip = false


new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
